// extracted by mini-css-extract-plugin
export default {"gridRowIsLow":"BETFillListGrid_gridRowIsLow__BNONI","gridRowIsHigh":"BETFillListGrid_gridRowIsHigh__Ub85o"};